import gql from 'graphql-tag';

const GET_USERS = gql`
	{
		users {
			id
			firstname
			lastname
			email
			enabled
			group {
				id
				name
			}
		}
	}
`;

const CREATE_USER = gql`
	mutation(
		$firstname: String!
		$lastname: String!
		$email: String!
		$group: String
	) {
		user: createUser(
			firstname: $firstname
			lastname: $lastname
			email: $email
			group: $group
		) {
			id
			firstname
			lastname
			email
			group {
				id
				name
			}
		}
	}
`;

const UPDATE_USER = gql`
	mutation(
		$id: ID!
		$firstname: String
		$lastname: String
		$email: String
		$enabled: Boolean
		$group: String
	) {
		user: updateUser(
			id: $id
			firstname: $firstname
			lastname: $lastname
			email: $email
			enabled: $enabled
			group: $group
		) {
			id
			firstname
			lastname
			email
			enabled
			group {
				id
				name
			}
		}
	}
`;

const DELETE_USER = gql`
	mutation($id: String!) {
		deleteUser(id: $id)
	}
`;

export {
	GET_USERS,
	CREATE_USER,
	UPDATE_USER,
	DELETE_USER,
};



// WEBPACK FOOTER //
// ./src/usersTable/queries.js